/*
 * Copyright (c) 2018 Infowijs.
 * Created by Thomas Schoffelen.
 */

let districtSchoolsTimer = null

function selectDistrictSchool (el, slug) {
  if (districtSchoolsTimer) {
    clearInterval(districtSchoolsTimer)
    districtSchoolsTimer = null
  }

  $('.school-item.active, .nav-schools-list .active').removeClass('active')
  $(el).parent().addClass('active')
  $('#school-item-' + slug).addClass('active')
}

function startDistrictSchoolSlider () {
  if (districtSchoolsTimer) {
    return
  }
  if ($(window).width() < 1024) {
    return
  }

  districtSchoolsTimer = setInterval(function () {
    const $x = $('.school-item.active')
    let $s = $x.next()
    if (!$s.length) {
      $s = $('.school-item').first()
    }
    $x.removeClass('active')
    $s.addClass('active')
    $('.nav-schools-list .active').removeClass('active')
    $('#nav-' + $s.attr('id')).addClass('active')
  }, 3000)
}

if ($('body').hasClass('district-home')) {
  startDistrictSchoolSlider()
}
